import { apiClient } from "lib/apiClient";
import { IPortfolioSelection } from "./getPortfolioSelection";

export interface IPortfolioSubjectSelection {
  propertySubjectId: string;
  selected: boolean;
}

export const updatePortfolioSelection = async (
  subjects: IPortfolioSubjectSelection[]
): Promise<IPortfolioSelection> => {
  const response = await apiClient.post("/portfolio/selection", subjects);

  return response.data;
};
